import type { Drama } from '@/types';

export const dramas: Drama[] = [
  {
    id: 'seoul-nocturne',
    title: '首尔夜曲',
    titleEn: 'Seoul Nocturne',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20romance%20drama%20poster%20art%2C%20elegant%20young%20couple%20under%20warm%20street%20lights%20on%20a%20rainy%20Seoul%20night%2C%20glowing%20amber%20reflections%2C%20deep%20red%20accent%20tones%2C%20soft%20bokeh%2C%20moody%20romantic%20atmosphere%2C%20elegant%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=kd-drama-01-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20rainy%20Seoul%20city%20street%20at%20night%2C%20neon%20signs%20and%20warm%20amber%20glow%2C%20reflective%20wet%20pavement%2C%20romantic%20moody%20atmosphere%2C%20soft%20rain%20bokeh%2C%20deep%20red%20and%20gold%20tonality%2C%20high%20detail%20cinematic%20photography%2C%20no%20text&width=1600&height=900&seq=kd-drama-01-backdrop&orientation=landscape',
    genres: ['爱情', '都市'],
    year: 2026,
    episodes: 16,
    status: '更新中',
    rating: 8.9,
    heat: 9850,
    director: '金成允',
    cast: ['lee-jieun', 'park-seojun'],
    synopsis:
      '深夜电台主播尹瑞妍总在凌晨三点为陌生听众读诗，直到某天，一位自称“夜曲”的常客点播了她最爱的那首老歌。声音背后的男人是刚回国的钢琴家姜道贤，两人的生活沿着首尔的夜色一点点交叠。当城市沉睡，他们才敢承认，有些心动只能在黑夜里发生。',
    tags: ['高甜', '双向奔赴', '治愈系'],
    episodeList: [
      { ep: 1, title: '凌晨三点的点播', summary: '瑞妍接到一个神秘点播，声音熟悉得让她指尖发颤。' },
      { ep: 2, title: '雨中错过的伞', summary: '道贤把伞留给了没带伞的陌生人，却在电台楼下撞见她。' },
      { ep: 3, title: '旧琴键上的名字', summary: '一架尘封的钢琴，藏着两人十年前就有的交集。' },
      { ep: 4, title: '第一首未寄出的诗', summary: '瑞妍念出了那首从未公开的诗，道贤在雨里停住了脚步。' },
    ],
  },
  {
    id: 'silent-testimony',
    title: '无声证词',
    titleEn: 'Silent Testimony',
    poster: 'https://readdy.ai/api/search-image?query=Gritty%20cinematic%20crime%20thriller%20poster%20art%2C%20weary%20detective%20in%20a%20dim%20interrogation%20room%2C%20single%20harsh%20lamp%20casting%20long%20shadows%2C%20cold%20charcoal%20and%20deep%20crimson%20accents%2C%20tense%20mysterious%20atmosphere%2C%20high%20detail%20noir%20photography%2C%20no%20text&width=600&height=800&seq=kd-drama-02-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Moody%20cinematic%20wide%20scene%20of%20an%20empty%20rainy%20industrial%20alley%20at%20night%2C%20flickering%20street%20lamp%20and%20distant%20police%20lights%2C%20cold%20blue%20charcoal%20shadows%20with%20a%20warm%20red%20glow%2C%20tense%20crime%20drama%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=1600&height=900&seq=kd-drama-02-backdrop&orientation=landscape',
    genres: ['悬疑', '犯罪'],
    year: 2025,
    episodes: 12,
    status: '已完结',
    rating: 9.1,
    heat: 9420,
    director: '崔东勋',
    cast: ['song-kangho', 'han-sohee'],
    synopsis:
      '一桩没有目击者、没有凶器的连环命案，唯一的线索是一段被人为抹去的人声录音。老刑警吴东根与声纹鉴定师徐敏珠联手，从沉默的声波里打捞出被掩埋的真相。每解开一层，他们都离那个最不该怀疑的人更近一步。',
    tags: ['高能反转', '犯罪', '群像'],
    episodeList: [
      { ep: 1, title: '缺失的三秒', summary: '录音里凭空消失的三秒钟，成了全案唯一的破口。' },
      { ep: 2, title: '声纹里的影子', summary: '敏珠在噪声底层捕捉到另一段被覆盖的呼吸。' },
      { ep: 3, title: '第二个证人', summary: '一位不愿露面的证人，用短信发来一张十年前的合照。' },
      { ep: 4, title: '沉默的代价', summary: '东根发现，沉默有时比谎言更伤人。' },
    ],
  },
  {
    id: 'shadow-throne',
    title: '王座之影',
    titleEn: 'Shadow of the Throne',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20historical%20Korean%20drama%20poster%20art%2C%20regal%20figure%20in%20ornate%20royal%20hanbok%20standing%20before%20a%20moonlit%20palace%20hall%2C%20dramatic%20candlelight%2C%20deep%20red%20gold%20and%20ink%20black%20tones%2C%20powerful%20cinematic%20atmosphere%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=kd-drama-03-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Grand%20cinematic%20wide%20scene%20of%20a%20vast%20traditional%20Korean%20royal%20palace%20at%20dusk%2C%20layered%20tiled%20roofs%20in%20golden%20haze%2C%20torchlight%20and%20deep%20red%20banners%2C%20epic%20historical%20atmosphere%2C%20dramatic%20sky%2C%20high%20detail%20photography%2C%20no%20text&width=1600&height=900&seq=kd-drama-03-backdrop&orientation=landscape',
    genres: ['历史', '宫廷'],
    year: 2025,
    episodes: 20,
    status: '已完结',
    rating: 8.7,
    heat: 8760,
    director: '李炳宪',
    cast: ['kim-taeri', 'lee-dohyun'],
    synopsis:
      '少年君王登基那日，朝堂之上没有一个人真心臣服。为了守住父王留下的江山，他不得不与最信任的护卫、最聪慧的女官联手，在刀光与算计之间行走。王座之下阴影丛生，而真正决定王朝命运的，从来不是权谋，而是人心。',
    tags: ['宫廷斗争', '史诗', '群像'],
    episodeList: [
      { ep: 1, title: '登基之日', summary: '新王加冕，第一道密旨便指向了先王的旧臣。' },
      { ep: 2, title: '殿前失火', summary: '一场意外的大火，烧出了藏在夹墙里的密信。' },
      { ep: 3, title: '女官的棋局', summary: '她以一盘棋，换回了三位老臣的性命。' },
      { ep: 4, title: '暗流', summary: '朝堂看似平静，暗处的棋子却已悄然落下。' },
    ],
  },
  {
    id: 'stardust-lovers',
    title: '星屑恋人',
    titleEn: 'Stardust Lovers',
    poster: 'https://readdy.ai/api/search-image?query=Dreamlike%20fantasy%20romance%20drama%20poster%20art%2C%20figure%20reaching%20toward%20swirling%20stardust%20under%20a%20vast%20starry%20sky%2C%20glowing%20particles%20and%20soft%20violet%20amber%20nebula%2C%20ethereal%20magical%20romantic%20atmosphere%2C%20surreal%20high%20detail%20art%2C%20no%20text&width=600&height=800&seq=kd-drama-04-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Dreamlike%20cinematic%20wide%20scene%20of%20a%20lone%20figure%20on%20a%20cliff%20beneath%20a%20vast%20aurora%20star%20filled%20sky%2C%20glowing%20stardust%20and%20soft%20nebula%20clouds%2C%20ethereal%20romantic%20fantasy%20atmosphere%2C%20surreal%20high%20detail%20art%2C%20no%20text&width=1600&height=900&seq=kd-drama-04-backdrop&orientation=landscape',
    genres: ['奇幻', '爱情'],
    year: 2026,
    episodes: 14,
    status: '更新中',
    rating: 8.5,
    heat: 8210,
    director: '朴赞郁',
    cast: ['jun-jihyun', 'cha-eunwoo'],
    synopsis:
      '天文学家车宇宙坚信，每一颗坠落的星屑都是一段没能说出口的告别。直到某个流星雨之夜，一位自称来自星星另一端的少女出现在他的观测台。她只记得三个名字，其中一个，正是他早已过世的母亲。',
    tags: ['奇幻', '治愈', '浪漫'],
    episodeList: [
      { ep: 1, title: '流星坠落之夜', summary: '观测台的屋顶裂开一道缝，落下一颗会呼吸的光。' },
      { ep: 2, title: '三个名字', summary: '少女写下三个名字，最后一个让宇宙彻夜未眠。' },
      { ep: 3, title: '消失的星图', summary: '她指尖划过的地方，星图上的星星一颗颗熄灭。' },
      { ep: 4, title: '第一次告别', summary: '宇宙终于明白，有些相遇本身就是告别。' },
    ],
  },
  {
    id: 'gangnam-cafe',
    title: '江南咖啡屋',
    titleEn: 'Gangnam Cafe',
    poster: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20comedy%20drama%20poster%20art%2C%20friendly%20barista%20smiling%20behind%20a%20sunlit%20coffee%20counter%2C%20steaming%20cups%20and%20steaming%20espresso%20machine%2C%20vibrant%20orange%20cream%20and%20warm%20brown%20tones%2C%20cheerful%20inviting%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-drama-05-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Bright%20cozy%20cinematic%20wide%20scene%20inside%20a%20trendy%20Gangnam%20cafe%2C%20warm%20sunlight%20through%20large%20windows%2C%20wooden%20furniture%20and%20green%20plants%2C%20vibrant%20orange%20and%20cream%20tones%2C%20welcoming%20lifestyle%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=1600&height=900&seq=kd-drama-05-backdrop&orientation=landscape',
    genres: ['喜剧', '都市'],
    year: 2025,
    episodes: 12,
    status: '已完结',
    rating: 8.2,
    heat: 7340,
    director: '申元浩',
    cast: ['park-seojun', 'han-sohee'],
    synopsis:
      '过气偶像出身的姜河路开了间藏在江南小巷里的咖啡屋，本想过清净日子，却陆续迎来一群比剧本还离谱的常客。前经纪人天天来蹭咖啡，落魄编剧在这里赶稿，还有个神秘女子每晚固定点同一杯“不存在的特调”。笑声背后，每个人都藏着一点点温柔。',
    tags: ['治愈', '轻喜剧', '群像'],
    episodeList: [
      { ep: 1, title: '重新开张', summary: '河路的咖啡屋开张第一天，只来了一位客人，却点了十杯。' },
      { ep: 2, title: '不存在的特调', summary: '那杯只在菜单背面的咖啡，藏着一段旧日恋情。' },
      { ep: 3, title: '蹭咖啡的前经纪人', summary: '前经纪人带着一份“必火计划”闯了进来。' },
      { ep: 4, title: '深夜打烊后', summary: '打烊后的咖啡屋，成了这城市最贵的树洞。' },
    ],
  },
  {
    id: 'echoes-abyss',
    title: '深渊回响',
    titleEn: 'Echoes of the Abyss',
    poster: 'https://readdy.ai/api/search-image?query=Dark%20horror%20thriller%20drama%20poster%20art%2C%20terrified%20figure%20standing%20at%20the%20edge%20of%20a%20black%20water%20tank%2C%20faint%20amber%20glow%20from%20below%2C%20eerie%20mist%20and%20deep%20crimson%20accents%2C%20oppressive%20suspenseful%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-drama-06-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Eerie%20cinematic%20wide%20scene%20of%20a%20flooded%20abandoned%20underground%20tunnel%2C%20still%20black%20water%20reflecting%20a%20single%20warm%20lamp%2C%20hanging%20mist%20and%20deep%20red%20glow%2C%20tense%20horror%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=1600&height=900&seq=kd-drama-06-backdrop&orientation=landscape',
    genres: ['悬疑', '惊悚'],
    year: 2026,
    episodes: 10,
    status: '更新中',
    rating: 8.8,
    heat: 8890,
    director: '罗泓轸',
    cast: ['song-kangho', 'kim-taeri'],
    synopsis:
      '潜水员在一座废弃水厂底部，发现了一扇不该存在的门。门后用古老的文字刻着一句话：回声会回来找你。当城里接连有人听见不存在的水声，警方与研究员不得不下潜到更深处，去面对那些被时间淹没的秘密。',
    tags: ['惊悚', '高能', '烧脑'],
    episodeList: [
      { ep: 1, title: '不该存在的门', summary: '水下四十米，门却在没有钥匙的情况下自己打开了。' },
      { ep: 2, title: '水声', summary: '整座城市的人，在同一个夜晚听见了下水道的呼吸。' },
      { ep: 3, title: '刻字的墙', summary: '墙上那行字，写的是三年前失踪者的名字。' },
      { ep: 4, title: '第二次下潜', summary: '这一次，他们带着录音设备，也带着恐惧。' },
    ],
  },
  {
    id: 'star-goryeo',
    title: '高丽星辰',
    titleEn: 'Star of Goryeo',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20war%20historical%20Korean%20drama%20poster%20art%2C%20armored%20general%20gazing%20at%20a%20burning%20battlefield%20horizon%2C%20dramatic%20embers%20and%20smoke%2C%20deep%20bronze%20gold%20and%20crimson%20tones%2C%20heroic%20cinematic%20atmosphere%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=kd-drama-07-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20scene%20of%20a%20vast%20ancient%20Korean%20battlefield%20at%20dusk%2C%20distant%20mountain%20fortress%20and%20smoldering%20watchfires%2C%20bronze%20gold%20and%20crimson%20sky%2C%20heroic%20grand%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=1600&height=900&seq=kd-drama-07-backdrop&orientation=landscape',
    genres: ['历史', '战争'],
    year: 2024,
    episodes: 24,
    status: '已完结',
    rating: 8.6,
    heat: 7980,
    director: '金汉珉',
    cast: ['lee-dohyun', 'kim-taeri'],
    synopsis:
      '高丽末年，边境小卒崔铉一路从烽火台爬上将军之位。他守护的不仅是国土，还有一个曾在乱世里救过他的女子。当外敌压境、朝中无人可信，他必须用手中那面残破的军旗，去撑起整个王朝最后的尊严。',
    tags: ['战争', '家国', '热血'],
    episodeList: [
      { ep: 1, title: '烽火台上的少年', summary: '第一缕狼烟升起时，他还没学会握剑。' },
      { ep: 2, title: '残旗', summary: '全军覆没的夜晚，他背回了一面只剩半边旗面的军旗。' },
      { ep: 3, title: '山中相逢', summary: '密林深处，那个救他的女子再次出现。' },
      { ep: 4, title: '第一场雪', summary: '雪落在战场上，也落在两人交错的命运上。' },
    ],
  },
  {
    id: 'our-summer',
    title: '我们的夏天',
    titleEn: 'Our Summer',
    poster: 'https://readdy.ai/api/search-image?query=Youthful%20romance%20drama%20poster%20art%2C%20two%20students%20riding%20bicycles%20down%20a%20sunlit%20tree%20lined%20road%20in%20summer%2C%20dappled%20green%20and%20golden%20light%2C%20warm%20nostalgic%20first%20love%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-drama-08-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Bright%20nostalgic%20cinematic%20wide%20scene%20of%20a%20sunlit%20summer%20school%20road%20lined%20with%20green%20trees%2C%20golden%20afternoon%20light%20and%20warm%20haze%2C%20hopeful%20youthful%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=1600&height=900&seq=kd-drama-08-backdrop&orientation=landscape',
    genres: ['青春', '爱情'],
    year: 2025,
    episodes: 16,
    status: '已完结',
    rating: 8.4,
    heat: 7620,
    director: '李应福',
    cast: ['cha-eunwoo', 'lee-jieun'],
    synopsis:
      '高三那年的暑假，转学生韩知晓在图书馆遇到了总坐在窗边的林夏。一个把喜欢写在草稿纸背面，一个把所有心事藏进随身听。十二年后的同学会，两人重新翻开那本被夹了纸条的旧书，才发现有些夏天从未结束。',
    tags: ['青春', '初恋', '治愈'],
    episodeList: [
      { ep: 1, title: '窗边的位置', summary: '她第一次走进图书馆，那个位置已经被人占了。' },
      { ep: 2, title: '草稿纸背面', summary: '一页没写完的公式，背面藏着一行小字。' },
      { ep: 3, title: '随身听里的歌', summary: '他把唯一的耳机塞给了她，两人听完了整首歌。' },
      { ep: 4, title: '毕业那天的雨', summary: '那天雨很大，他跑遍了整条街。' },
    ],
  },
  {
    id: 'chaebol-tutor',
    title: '财阀家教',
    titleEn: 'Chaebol Tutor',
    poster: 'https://readdy.ai/api/search-image?query=Stylish%20urban%20comedy%20drama%20poster%20art%2C%20confident%20young%20tutor%20with%20a%20textbook%20in%20a%20luxurious%20modern%20mansion%2C%20glass%20and%20marble%20interior%20with%20warm%20window%20glow%2C%20amber%20and%20charcoal%20tones%2C%20sharp%20witty%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-drama-09-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Glamorous%20cinematic%20wide%20scene%20of%20a%20modern%20Seoul%20penthouse%20at%20night%2C%20floor%20to%20ceiling%20windows%20overlooking%20the%20city%2C%20warm%20amber%20interior%20light%20and%20charcoal%20shadows%2C%20sophisticated%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=1600&height=900&seq=kd-drama-09-backdrop&orientation=landscape',
    genres: ['都市', '喜剧'],
    year: 2026,
    episodes: 16,
    status: '更新中',
    rating: 7.9,
    heat: 6890,
    director: '朴俊华',
    cast: ['jun-jihyun', 'park-seojun'],
    synopsis:
      '靠打零工读完师范的具河镇，被一份天价家教合约砸中，成了某财阀家最小的孩子唯一的老师。可他要教的不只是数学，还要应付争产的叔叔、装傻的管家，以及那个永远不按常理出牌的女主人。一场关于规则与真心的较量，从此在豪宅里开演。',
    tags: ['爽剧', '都市', '反转'],
    episodeList: [
      { ep: 1, title: '天价合约', summary: '合同最后一页写着一个他不敢签的名字。' },
      { ep: 2, title: '第一堂课', summary: '学生递来的不是作业，而是一份股权转让书。' },
      { ep: 3, title: '装傻的管家', summary: '管家无意间说漏的一句话，让河镇背后发凉。' },
      { ep: 4, title: '家宴', summary: '一场家宴，三方势力，一张被悄悄换掉的座位卡。' },
    ],
  },
  {
    id: 'moonlight-hospital',
    title: '月光医院',
    titleEn: 'Moonlight Hospital',
    poster: 'https://readdy.ai/api/search-image?query=Warm%20medical%20drama%20poster%20art%2C%20kind%20young%20doctor%20in%20a%20dim%20hospital%20corridor%20at%20night%2C%20soft%20moonlight%20through%20tall%20windows%2C%20calm%20teal%20and%20warm%20amber%20tones%2C%20hopeful%20tender%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-drama-10-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Calm%20cinematic%20wide%20scene%20of%20a%20quiet%20hospital%20corridor%20at%20night%2C%20soft%20moonlight%20and%20warm%20lamp%20glow%2C%20clean%20minimal%20interior%20with%20teal%20and%20amber%20tones%2C%20hopeful%20tender%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=1600&height=900&seq=kd-drama-10-backdrop&orientation=landscape',
    genres: ['医疗', '剧情'],
    year: 2025,
    episodes: 16,
    status: '已完结',
    rating: 8.5,
    heat: 7510,
    director: '申源浩',
    cast: ['han-sohee', 'lee-dohyun'],
    synopsis:
      '在一家濒临倒闭的社区医院里，外科医生徐恩星和儿科医生尹在河并肩守着最后几盏灯。他们没有顶尖的设备，只有一群不肯离开的同事和街坊。每一个深夜送来的病人，都是一段人间故事，也一次次考验着他们最初的誓言。',
    tags: ['医疗', '温情', '群像'],
    episodeList: [
      { ep: 1, title: '最后一盏灯', summary: '医院要关门的通知贴在门口，恩星却还在手术。' },
      { ep: 2, title: '深夜的病人', summary: '凌晨送来的一位老人，让整个科室安静了下来。' },
      { ep: 3, title: '不肯离开的同事', summary: '发不出工资的那个月，没有人递辞呈。' },
      { ep: 4, title: '月光之下', summary: '恩星和在河在天台交换了各自的秘密。' },
    ],
  },
  {
    id: 'memory-maze',
    title: '记忆迷宫',
    titleEn: 'Memory Maze',
    poster: 'https://readdy.ai/api/search-image?query=Sci%20fi%20thriller%20drama%20poster%20art%2C%20a%20man%20facing%20endless%20mirrored%20corridors%20of%20glowing%20memory%20fragments%2C%20cool%20steel%20blue%20with%20warm%20amber%20highlights%2C%20disorienting%20futuristic%20atmosphere%2C%20high%20detail%20concept%20art%2C%20no%20text&width=600&height=800&seq=kd-drama-11-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Futuristic%20cinematic%20wide%20scene%20of%20an%20endless%20glowing%20memory%20archive%20chamber%2C%20floating%20holographic%20fragments%20in%20steel%20blue%20light%20with%20warm%20amber%20accents%2C%20surreal%20sci%20fi%20atmosphere%2C%20high%20detail%20concept%20art%2C%20no%20text&width=1600&height=900&seq=kd-drama-11-backdrop&orientation=landscape',
    genres: ['科幻', '悬疑'],
    year: 2026,
    episodes: 12,
    status: '更新中',
    rating: 9.0,
    heat: 9120,
    director: '奉俊昊',
    cast: ['song-kangho', 'jun-jihyun'],
    synopsis:
      '近未来，人类的记忆可以被读取、编辑与交易。记忆修复师姜时宇接到一份特殊的委托：让一个人记起自己从未经历过的事。当他潜入对方的记忆迷宫，却发现每一层都藏着自己的脸。真相与幻觉的边界，正在一点点崩塌。',
    tags: ['科幻', '烧脑', '反转'],
    episodeList: [
      { ep: 1, title: '被删掉的童年', summary: '委托人想找回的，是一段根本不存在的记忆。' },
      { ep: 2, title: '第二层迷宫', summary: '越往下走，时宇越觉得镜子里的人眼熟。' },
      { ep: 3, title: '不属于他的脸', summary: '记忆的尽头，站着一个改了他名字的人。' },
      { ep: 4, title: '谁在回忆', summary: '当他在别人的记忆里醒来，问题变成了：我还存在吗？' },
    ],
  },
  {
    id: 'camellias-bloom',
    title: '山茶花开',
    titleEn: 'When Camellias Bloom',
    poster: 'https://readdy.ai/api/search-image?query=Tender%20family%20drama%20poster%20art%2C%20a%20mother%20and%20daughter%20standing%20in%20a%20camellia%20garden%20in%20soft%20morning%20light%2C%20blooming%20red%20camellia%20flowers%2C%20warm%20amber%20and%20earthy%20tones%2C%20heartfelt%20nostalgic%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-drama-12-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20scene%20of%20a%20rural%20Korean%20camellia%20garden%20in%20early%20spring%20morning%2C%20blooming%20red%20flowers%20and%20soft%20mist%2C%20golden%20light%20through%20branches%2C%20nostalgic%20heartwarming%20atmosphere%2C%20high%20detail%20photography%2C%20no%20text&width=1600&height=900&seq=kd-drama-12-backdrop&orientation=landscape',
    genres: ['家庭', '剧情'],
    year: 2024,
    episodes: 20,
    status: '已完结',
    rating: 9.2,
    heat: 8350,
    director: '卢熙京',
    cast: ['kim-taeri', 'han-sohee'],
    synopsis:
      '在半岛南端一座临海小镇，一家开了四十年的山茶食堂即将拆迁。掌勺的姐姐、出走的妹妹、守着一柜旧信的外婆，三代女人围绕着这座老屋，翻出被岁月压平的伤口与秘密。当山茶再次开满院子，她们终于学会与过去和解。',
    tags: ['家庭', '催泪', '群像'],
    episodeList: [
      { ep: 1, title: '拆迁通知', summary: '一张红纸贴在食堂门上，惊动了整个小镇。' },
      { ep: 2, title: '不回家的妹妹', summary: '出走了十年的妹妹，拖着行李箱站在了门口。' },
      { ep: 3, title: '一柜旧信', summary: '外婆锁了一辈子的信，收信人却从未出现。' },
      { ep: 4, title: '灶台上的味道', summary: '一道失传的菜，唤回了关于父亲的全部记忆。' },
    ],
  },
];